"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AppName", {
  enumerable: true,
  get: function get() {
    return _site_list.SiteName;
  }
});
exports.topLevelDomainByEnvName = exports.parseServerEnv = exports.getUrl = exports.getPort = exports.getAllUrls = void 0;

var _urlParse = _interopRequireDefault(require("url-parse"));

var _assert = require("assert");

var _site_list = _interopRequireWildcard(require("./site_list"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Get the URL for a site given an environment.
 */
var getUrl = function getUrl(app, envSettings) {
  (0, _assert.ok)(envSettings != null, 'envSettings is required');
  (0, _assert.ok)(_typeof(envSettings) === 'object', 'envSettings must be an object');
  var envName = parseServerEnv(envSettings);
  var site = _site_list.default[app] != null ? _site_list.default[app][envName] : undefined;

  if (site == null) {
    throw new Error("Could not find site ".concat(app, " for envSettings ").concat(envName));
  }

  var protocol = site.protocol,
      subdomain = site.subdomain,
      domain = site.domain;
  var topLevelDomain = domain != null ? domain : topLevelDomainByEnvName.get(envName);
  var port = site.port != null ? ":".concat(site.port) : '';
  var path = site.path != null ? site.path : '';
  var url = "".concat(protocol, "://").concat(subdomain, ".").concat(topLevelDomain).concat(port).concat(path);
  var useIpAddressForHttpRequests = parseUseIpAddressForHttpRequests(envSettings);
  var serverBind = parseServerBind(envSettings);

  if (useIpAddressForHttpRequests && serverBind != null) {
    var _url = new _urlParse.default(url);

    _url.set('protocol', 'http:');

    _url.set('hostname', serverBind);

    _url.set('port', getPort(app, envSettings));

    url = _url.toString();
  }

  return url;
};
/**
 * Get the bound port for a site given an environment. Presumably exclusively used by a site itself
 * to know what port to bind its web server to. DO NOT use to determine what port to use to access
 * a site. This should probably be called `getBoundPort` but that probably isn't worth a breaking change.
 */


exports.getUrl = getUrl;

var getPort = function getPort(app, envSettings) {
  (0, _assert.ok)(envSettings != null, 'envSettings is required');
  (0, _assert.ok)(_typeof(envSettings) === 'object', 'envSettings must be an object');

  if (!_site_list.default.hasOwnProperty(app)) {
    throw new Error("Could not find site with name ".concat(app));
  }

  var envName = parseServerEnv(envSettings);
  var site = _site_list.default[app][envName];
  return site != null ? site.boundPort : undefined;
};
/**
 * Get a list of all site URLs for a given environment. Useful for generating CORS/CSP lists or
 * similar.
 */


exports.getPort = getPort;

var getAllUrls = function getAllUrls(envSettings) {
  (0, _assert.ok)(envSettings != null, 'envSettings is required');
  (0, _assert.ok)(_typeof(envSettings) === 'object', 'envSettings must be an object');
  return Object.keys(_site_list.default).map(function (app) {
    return getUrl(app, envSettings);
  });
};
/**
 * Get the environment a server is running in based on its environment settings (a combination of
 * `env` and `appInstance`). Throws if the resulting environment is not a valid environment.
 */


exports.getAllUrls = getAllUrls;

var parseServerEnv = function parseServerEnv(envSettings) {
  (0, _assert.ok)(envSettings != null, 'envSettings is required');
  (0, _assert.ok)(_typeof(envSettings) === 'object', 'envSettings must be an object');
  var envName = envSettings.env; // Production and staging both use env=production, but differentiate on appInstance.

  if (envSettings.appInstance === 'staging') {
    envName = 'staging';
  }

  if (envName !== 'development' && envName !== 'test' && envName !== 'staging' && envName !== 'production') {
    throw new Error("Unrecognized environment '".concat(envName, "' (Valid environments: development, production, staging, test)"));
  }

  return envName;
};
/**
 * We implicitly assume the TLDs are uniform across all internal services for an appInstance in
 * various contexts (e.g.  UI apps use a shared auth cookie for the TLD, e.g. *.goodeggs.com), so we
 * might as well make this explicit here.
 */


exports.parseServerEnv = parseServerEnv;
var topLevelDomainByEnvName = new Map([['development', 'goodeggs.test'], ['test', 'goodeggs.test'], ['staging', 'huevosbuenos.com'], ['production', 'goodeggs.com']]);
exports.topLevelDomainByEnvName = topLevelDomainByEnvName;

var parseUseIpAddressForHttpRequests = function parseUseIpAddressForHttpRequests(envSettings) {
  return envSettings.useIpAddressForHttpRequests || false;
};

var parseServerBind = function parseServerBind(envSettings) {
  if (envSettings.server != null && envSettings.server.bind != null) {
    return envSettings.server.bind;
  }

  return null;
};
//# sourceMappingURL=index.js.map